<template>
    <div v-if="checkWebsitePermission(permissionTypes.websiteReadSpecific, this.$route.params.id)" class="container-fluid main-content-container ">
        <div class="row no-gutters py-4">
            <website-detail />
        </div>

        <list-connection-network/>
        <connected-integrations/>
        <website-settings :website-id="this.$route.params.id" />

        <modal :adaptive="true" height="auto" name="edit">
            <d-row>
                <d-col lg="12">
                    <d-card >
                        <d-card-header class="border-bottom">Edit Domain</d-card-header>
                        <d-card-body v-if="websites">
                            <d-col>
                                <d-form id="domainForm" @submit.prevent="update">
                                    <d-form-row class="mt-3">
                                        <d-col md="12" class="form-group">
                                            <label for="url">URL:</label>
                                            <d-form-input type="text" id="url" v-model="websites.domain" />
                                        </d-col>
                                        <d-col md="12" class="form-group">
                                            <label for="currency">Currency:</label>
                                            <d-form-select v-model="websites.currency.id">
                                                <option v-for="currency in currencies" :value="currency.id">{{ currency.name }}</option>
                                            </d-form-select>
                                        </d-col>
                                        <d-col md="12" class="form-group d-flex justify-content-end">
                                            <button type="button" @click="hideEditModal" class="btn btn-secondary">Close without saving</button>
                                            <input value="Save" type="submit" class="btn ml-1 btn-success">
                                        </d-col>
                                    </d-form-row>
                                </d-form>
                            </d-col>
                        </d-card-body>
                    </d-card>
                </d-col>
            </d-row>
        </modal>
    </div>
    <div v-else class="container-fluid main-content-container ">
        <br>
        <no-permission-message />
    </div>
</template>


<script>
import { WebsiteService, UserService, AffiliateNetworkService, ErrorService } from '@/main';
import WebsiteDetail from '@/views/media/DetailTable.vue';
import ConnectedIntegrations from '@/views/integrations/IntegrationList.vue';
import WebsiteSettings from '@/components/website/Settings.vue';
import ListConnectionNetwork from '@/views/media/ListConnectionNetwork.vue';
import currency from '@/mixins/currency';
import notification from '@/mixins/notification';
import permissions from "@/mixins/permissions";
import * as Sentry from "@sentry/browser";

export default {
    mixins: [currency, notification, permissions],
    name: 'website',

    components: {
        WebsiteDetail,
        ConnectedIntegrations,
        ListConnectionNetwork,
        WebsiteSettings,
    },

    data() {
        return {
            currencies: [],
            websites: null
        };
    },

    watch: {
        $route(to, from) {
            this.getWebsite()
        }
    },

    methods: {
        async update() {
            try {
                await WebsiteService.update(this.websites)
                this.showNotification('success', 'Alert', 'Domain successfully edited!')
                this.$router.go()
            } catch (e) {
                let message = ErrorService.getErrorMessage(e.networkError.result.errors[0])
                if (message === 'This domain already added!') {
                    message += ' Please, contact us via bart@ivanhoe.io OR signup with a different domain'
                } else {
                    Sentry.captureException(e);
                }

                this.showNotification('warn', 'Oops! We have a problem', message)
                console.log(e)
            }
        },

        hideEditModal() {
            this.$modal.hide('edit');
        },

        async getWebsite() {
            this.websites = await WebsiteService.getById(this.$route.params.id)
        }
    },

    created () {
        this.getWebsite()
    }
};
</script>
